import React, { useState } from "react";
import { Delete } from "lucide-react";

// Reusable tactile PIN pad. Calls onComplete(pin) when `length` digits entered.
export default function PinPad({ length = 4, onComplete, error }) {
  const [pin, setPin] = useState("");
  const [rippleKey, setRippleKey] = useState(null);

  const press = (d) => {
    if (pin.length >= length) return;
    const next = pin + d;
    setPin(next);
    setRippleKey(d + ":" + Date.now());
    if (next.length === length) {
      setTimeout(() => {
        onComplete(next);
        setPin("");
      }, 150);
    }
  };

  const del = () => setPin((p) => p.slice(0, -1));

  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "del"];

  return (
    <div className="flex flex-col items-center">
      <div data-testid="pin-input-container" className="mb-9 flex items-center gap-4">
        {Array.from({ length }).map((_, i) => (
          <span
            key={i}
            className={`h-4 w-4 rounded-full border transition-all duration-200 ${
              i < pin.length ? "border-neon bg-neon neon-glow" : "border-[#2A2F3D] bg-transparent"
            }`}
          />
        ))}
      </div>
      {error && (
        <p data-testid="pin-error" className="mb-5 font-sans text-sm text-[#EF4444]">
          {error}
        </p>
      )}
      <div className="grid grid-cols-3 gap-4">
        {keys.map((k, idx) => {
          if (k === "") return <span key={idx} />;
          if (k === "del")
            return (
              <button
                key={idx}
                data-testid="pin-delete-button"
                onClick={del}
                className="flex h-[70px] w-[70px] items-center justify-center rounded-full text-[#9CA3AF] transition-colors hover:text-white active:scale-95"
              >
                <Delete className="h-6 w-6" />
              </button>
            );
          return (
            <button
              key={idx}
              data-testid="pin-digit-button"
              onClick={() => press(k)}
              className="relative flex h-[70px] w-[70px] items-center justify-center overflow-hidden rounded-full border border-[#1F2430] bg-[#12141A] font-rajdhani text-2xl font-semibold text-white transition-all hover:border-neon/40 hover:bg-[#1A1D26] active:scale-95"
            >
              {rippleKey && rippleKey.startsWith(k + ":") && (
                <span key={rippleKey} className="pin-ripple absolute inset-0 rounded-full" />
              )}
              {k}
            </button>
          );
        })}
      </div>
    </div>
  );
}
